"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCardActionButtons = exports.ActionButtonLink = exports.ActionButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../../../../..");
const ActionCard_styles_1 = require("../../ActionCard.styles");
const ActionCard_utils_1 = require("../../ActionCard.utils");
/** This is a very small wrapper around the Button element
 * It allows us to ensure only correctly styled buttons are used
 */
// N.B. Can't do a normal styled(Button) here as it messes with the Jest tests ¯\_(ツ)_/¯
// see https://github.com/styled-components/styled-components/issues/1449
exports.ActionButton = (0, styled_components_1.default)((props) => (react_1.default.createElement(__1.Button, Object.assign({}, props)))) `
    width: 100%;
    justify-content: center;
`;
exports.ActionButton.displayName = "ActionCard.ActionButton";
/** This is a very small wrapper around the Button element
 * It allows us to ensure only correctly styled buttons are used
 */
// N.B. Can't do a normal styled(Button) here as it messes with the Jest tests ¯\_(ツ)_/¯
// see https://github.com/styled-components/styled-components/issues/1449
exports.ActionButtonLink = (0, styled_components_1.default)((props) => (react_1.default.createElement(__1.ButtonLink, Object.assign({}, props)))) `
    width: 100%;

    & > span {
        width: 100%;
        justify-content: center;
    }
`;
exports.ActionButtonLink.displayName = "ActionCard.ActionButtonLink";
/**
 * This is a layout wrapper which allows the user to put 1 or 2 ActionButton
 * elements (exported above) in the footer of the card
 */
const ActionCardActionButtons = ({ children, }) => {
    react_1.default.Children.forEach(children, (child) => {
        (0, ActionCard_utils_1.checkChildrenAreValid)(child, ["ActionCard.ActionButton", "ActionCard.ActionButtonLink"]);
    });
    // There can only be 1 or 2 children
    (0, ActionCard_utils_1.checkContainsNumbersOfChildren)({ children, minNumber: 1, maxNumber: 2 });
    return react_1.default.createElement(ActionCard_styles_1.ButtonsContainer, null, children);
};
exports.ActionCardActionButtons = ActionCardActionButtons;
exports.ActionCardActionButtons.displayName = "ActionCardActionButtons";
//# sourceMappingURL=ActionCardActionButtons.js.map